import React, { useEffect, useState } from 'react';
import { Form, Input, DatePicker, Upload, Button } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import CBModal from './CBModal';
import { echangesPartenaires } from '../services/echangesPartenaires';

const GREEN = '#1a6b3c';

/**
 * La réponse d'un partenaire est arrivée (courrier, courriel hors messagerie, remise en
 * main propre) : elle est enregistrée comme courrier reçu de lui, et l'attente est close.
 */
export default function ReponseRecueModal({ open, onClose, ligne, onEnregistre }) {
  const { t } = useTranslation('commun');
  const [form] = Form.useForm();
  const [fichier, setFichier] = useState(null);
  const [envoi, setEnvoi] = useState(false);

  useEffect(() => {
    if (!open) return;
    form.resetFields();
    form.setFieldsValue({ dateReception: dayjs() });
    setFichier(null);
  }, [open, form]);

  const valider = async () => {
    const v = await form.validateFields();
    setEnvoi(true);
    try {
      await echangesPartenaires.reponseRecue(ligne.courrierTrackingId, {
        dateReception: v.dateReception.format('YYYY-MM-DD'),
        objet: v.objet || null,
        observations: v.observations || null,
      }, fichier);
      toast.success(t('reponseRecueModal.reponseEnregistree', { organisme: ligne.organisme || t('reponseRecueModal.duPartenaire') }));
      onEnregistre?.();
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.message || t('reponseRecueModal.echecEnregistrement'));
    } finally {
      setEnvoi(false);
    }
  };

  return (
    <CBModal
      title={t('reponseRecueModal.titre', { organisme: ligne?.organisme || '' })}
      open={open}
      onCancel={onClose}
      onOk={valider}
      okText={t('reponseRecueModal.enregistrer')}
      cancelText={t('reponseRecueModal.annuler')}
      confirmLoading={envoi}
      okButtonProps={{ style: { background: GREEN, borderColor: GREEN } }}
    >
      <div style={{ fontSize: 12.5, color: '#6b7280', marginBottom: 12 }}>{t('reponseRecueModal.enReponseA', { objet: ligne?.objet })}</div>
      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.Item name="dateReception" label={t('reponseRecueModal.recueLe')} rules={[{ required: true, message: t('reponseRecueModal.dateRequise') }]}>
          <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} disabledDate={(d) => d && d.isAfter(dayjs(), 'day')} />
        </Form.Item>
        <Form.Item name="objet" label={t('reponseRecueModal.objet')}>
          <Input maxLength={250} placeholder={t('reponseRecueModal.objetPlaceholder')} />
        </Form.Item>
        <Form.Item name="observations" label={t('reponseRecueModal.observations')}>
          <Input.TextArea rows={3} maxLength={2000} />
        </Form.Item>
        <Upload
          accept=".pdf,.jpg,.jpeg,.png" maxCount={1}
          beforeUpload={(f) => { setFichier(f); return false; }}
          onRemove={() => setFichier(null)}
        >
          <Button icon={<PaperClipOutlined />}>{t('reponseRecueModal.joindre')}</Button>
        </Upload>
      </Form>
    </CBModal>
  );
}
